import type { LucideIcon, LucideProps } from "lucide-react";

import React from "react";

// Create the icon using the same pattern as lucide-react
const LineHeight: LucideIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      className = "",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={color}
        className={className}
        {...props}
      >
        <path
          d="M12 6H22M10 12H19M12 18H22"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 17L5 20M5 20L8 17M5 20V14"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 6L5 3M5 3L8 6M5 3V9"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

// Add display name for React DevTools
LineHeight.displayName = "LineHeight";

export default LineHeight;
